import React, { FC } from 'react'
import PaginationButtons from '../../../../PaginationButtons'
import { ImmunizationBundle } from '../../../../../types/FHIRTypes/Bundle'
import { isImmunizationBundle } from '../../../../../typeGuards/fhirTypes'
import { ImmunizationTable } from '@teschglobal/tg-fhir-react-components'
import FhirLoader from '../../../../FhirLoader'

type ImmunizationListProps = {
  immunizationData: ImmunizationBundle;
  isFetching: boolean;
  handleChangePage: (page: number) => void
  totalPages: number;
  currentPage: number;
}

const ImmunizationList: FC<ImmunizationListProps> = ({ immunizationData, isFetching, handleChangePage, totalPages, currentPage }) => {
  if (!isImmunizationBundle(immunizationData)) return null

  const immunizations = immunizationData && immunizationData.entry ? immunizationData.entry.map((immunization) => immunization.resource) : []

  if (isFetching) {
    return <FhirLoader message="Loading..." />
  }

  return (
    <>
      {
        immunizationData?.total > 0 && (
          <div className='my-3 fw-bold'>
            <span role="status" aria-live="polite">{immunizationData?.total.toLocaleString()} record(s) found</span>
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              handleChangePage={handleChangePage}
            />
          </div>
        )
      }
      <ImmunizationTable
        immunizations={immunizations}
      />
      {
        immunizationData?.total > 0 && (
          <div className='my-3 fw-bold'>
            <PaginationButtons
              totalPages={totalPages}
              currentPage={currentPage}
              handleChangePage={handleChangePage}
            />
          </div>
        )
      }
    </>
  )
}

export default ImmunizationList